import React, { useEffect } from 'react'
import { useTimerContext } from "src/hooks"
import { getSecondsWord } from "src/helpers"
import './Timer.scss'

const Timer = () => {
    const { currentTime, turnOnTimer } = useTimerContext()

    useEffect(() => {
        turnOnTimer()
    }, [])

    return (
        <div className={"timer"}>
            Продолжим через {currentTime} {getSecondsWord(currentTime)}
        </div>
    )
}

export default Timer